import { useTranslation } from 'react-i18next';
import { getDurationFormatKey } from '@/utils/datetime';
import cn from '@/utils/merge-class-names';
import { translateComplexKey } from '@/utils/translate';

interface Props {
  duration: number | null | undefined;
  withUnits?: boolean;
  className?: string;
  compact?: boolean;
}

export default function DurationDisplay({ withUnits, duration, className, compact }: Props) {
  const { t } = useTranslation();

  if (typeof duration !== 'number') return null;

  return (
    <span className={cn('whitespace-nowrap', className)}>
      {translateComplexKey(getDurationFormatKey(duration, withUnits, compact), t)}
    </span>
  );
}
